
<v-dialog v-model="show" class="mt-5" persistent scrollable :max-width="$vuetify.breakpoint.mobile ? '95%' : '50%'">
	<v-card class="justify-center text-center card-rounded pb-2">
		<v-card-title
			class="pa-2 white--text justify-center text-center secondary"
			style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
		>
			<v-row>
				<v-spacer></v-spacer>
				<span class="headline white--text">Preview your profile</span>
				<v-spacer></v-spacer>
			</v-row>
			<v-btn icon color="white" @click="dismissFeaturedLocums">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>

		<v-card-text class="text-center justify-center mt-4">
			<v-row class="justify-center">
				<v-col cols="12" md="8">
					<view-locum-details-card :locum-preview-id="user.id" source="previewLocumProfile"></view-locum-details-card>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</v-dialog>
